import { useEffect } from "react";
import { Lang } from "@/types";

export function useSeo(title: string, description: string, lang: Lang, schema?: object) {
  useEffect(() => {
    document.title = title;
    document.documentElement.lang = lang;
    const setMeta = (name: string, value: string) => {
      let node = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
      if (!node) { node = document.createElement("meta"); node.name = name; document.head.appendChild(node); }
      node.content = value;
    };
    setMeta("description", description);
    const localizedPath = (target: Lang) => {
      let path = window.location.pathname.replace(/^\/(de|en)/, `/${target}`);
      const pairs = target === "en"
        ? [["/leistungen/", "/services/"], ["/orte/", "/areas/"], ["/angebot", "/quote"], ["/impressum", "/imprint"], ["/datenschutz", "/privacy"]]
        : [["/services/", "/leistungen/"], ["/areas/", "/orte/"], ["/quote", "/angebot"], ["/imprint", "/impressum"], ["/privacy", "/datenschutz"]];
      pairs.forEach(([from, to]) => { path = path.replace(from, to); });
      return path;
    };
    const setLink = (rel: string, href: string, hreflang?: string) => {
      const selector = hreflang ? `link[rel="${rel}"][hreflang="${hreflang}"]` : `link[rel="${rel}"]:not([hreflang])`;
      let node = document.querySelector(selector) as HTMLLinkElement | null;
      if (!node) { node = document.createElement("link"); node.rel = rel; if (hreflang) node.hreflang = hreflang; document.head.appendChild(node); }
      node.href = href;
    };
    setLink("canonical", `https://piccobellochiemsee.de${localizedPath(lang)}`);
    setLink("alternate", `https://piccobellochiemsee.de${localizedPath("de")}`, "de");
    setLink("alternate", `https://piccobellochiemsee.de${localizedPath("en")}`, "en");
    document.querySelector("#page-schema")?.remove();
    if (schema) { const node = document.createElement("script"); node.id = "page-schema"; node.type = "application/ld+json"; node.text = JSON.stringify(schema); document.head.appendChild(node); }
  }, [title, description, lang, schema]);
}